import axiosInstance from "./axiosInstance"; // Import the axios instance

export const loginRestaurant = async (restaurant_name) => {
  try {
    const response = await axiosInstance.post("/auth/restaurant", {
      restaurant_name,
    });

    return response.data; // Return the API response
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Login failed. Please try again."
    );
  }
};

export const loginByInvite = async (token) => {
  try {
    const response = await axiosInstance.post("/auth/restaurant", { token });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Invite link is invalid or has expired."
    );
  }
};

export const bootstrapSuperAdmin = async () => {
  try {
    const response = await axiosInstance.post("/auth/restaurant", {
      super_admin: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Unable to start super admin login."
    );
  }
};

export const loginAdmin = async (username, password) => {
  try {
    const response = await axiosInstance.post("/auth/login", {
      username,
      password,
    });
    return response.data; // Return the API response
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Admin login failed. Please try again."
    );
  }
};

export const requestEmailVerification = async (email) => {
  try {
    const response = await axiosInstance.post(
      "/auth/email/request-verification",
      {
        email,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to send verification code. Please try again."
    );
  }
};

export const verifyEmailCode = async (email, code) => {
  try {
    const response = await axiosInstance.post("/auth/email/verify", {
      email,
      code,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Invalid verification code. Please try again."
    );
  }
};

export const logout = () => {
  localStorage.removeItem("token");
};
